import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["existingPermissionAccessRequest", "appLocationLabel"],
  _excluded2 = ["taskDescription", "hasRequestAccessConfig", "isExistingPermissionAccessRequestLoading", "requestAccessConfig", "onRequestAccessSuccess"],
  _excluded3 = ["taskDescription", "requestAccessConfig"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useContext } from 'react';
import { AccessCheckAccessInfoContext } from '../../../../contexts/AccessCheckAccessInfoContext';
import { useExistingPermissionAccessRequestQuery } from '../../../../hooks/useExistingPermissionAccessRequestQuery';
import { MissingSeatsAndPermissionsList } from '../../../internal/Shared/MissingSeatsAndPermissionsList';
import { RequestAccessTrigger } from '../../../internal/RequestAccess/RequestAccessTrigger';
import { formatAccessRequestDate } from '../../../../utils/formatAccessRequestDate';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ExistingRequestFullPageDisplay(_ref) {
  let {
      existingPermissionAccessRequest,
      appLocationLabel
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const formattedCreatedAt = formatAccessRequestDate(existingPermissionAccessRequest.createdAt);
  return /*#__PURE__*/_jsx(ErrorMessage, Object.assign({
    illustration: "successful-send",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "access-check-lib.accessCheck.messaging.fullPage.existingRequest.title",
      options: {
        appLocationLabel,
        createdAt: formattedCreatedAt
      }
    })
  }, rest, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "access-check-lib.accessCheck.messaging.fullPage.existingRequest.body"
    })
  }));
}
function BlockedFullPageDisplay(_ref2) {
  var _accessInfo$missingPe;
  let {
      taskDescription,
      hasRequestAccessConfig,
      isExistingPermissionAccessRequestLoading,
      requestAccessConfig,
      onRequestAccessSuccess
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const accessInfo = useContext(AccessCheckAccessInfoContext);
  const totalMissingItems = accessInfo.missingPermissions.length + accessInfo.missingSeats.length;
  return /*#__PURE__*/_jsx(ErrorMessage, Object.assign({
    illustration: "lock",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "access-check-lib.accessCheck.messaging.fullPage.blockedTask",
      options: {
        taskDescription
      }
    })
  }, rest, {
    children: hasRequestAccessConfig && isExistingPermissionAccessRequestLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered"
    }) : hasRequestAccessConfig ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Paragraph, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "access-check-lib.accessCheck.messaging.fullPage.requestAccessDescription"
        })
      }), /*#__PURE__*/_jsx(RequestAccessTrigger, {
        requestAccessConfig: requestAccessConfig,
        taskDescription: taskDescription,
        onRequestAccessSuccess: onRequestAccessSuccess,
        children: openModal => /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: openModal,
          "data-test-id": "request-access-cta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "access-check-lib.accessCheck.messaging.requestAccess.action"
          })
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [totalMissingItems > 1 && /*#__PURE__*/_jsx(TFlex, {
        flexDirection: "column",
        alignItems: "center",
        children: /*#__PURE__*/_jsx(MissingSeatsAndPermissionsList, {
          accessInfo: accessInfo,
          marginStyleProps: {
            marginBlockEnd: '200'
          }
        })
      }), totalMissingItems === 1 && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "access-check-lib.accessCheck.messaging.fullPage.requiredSinglePermission",
        options: {
          permissionName: (_accessInfo$missingPe = accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.missingPermissions[0]) !== null && _accessInfo$missingPe !== void 0 ? _accessInfo$missingPe : accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.missingSeats[0]
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "access-check-lib.accessCheck.messaging.adminResolveAction"
      })]
    })
  }));
}
export function FullPageDisplay(_ref3) {
  var _requestAccessConfig$;
  let {
      taskDescription,
      requestAccessConfig
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  const appLocationId = requestAccessConfig === null || requestAccessConfig === void 0 || (_requestAccessConfig$ = requestAccessConfig.appLocation) === null || _requestAccessConfig$ === void 0 ? void 0 : _requestAccessConfig$.id;
  const hasRequestAccessConfig = !!appLocationId;
  const {
    existingPermissionAccessRequest,
    isExistingPermissionAccessRequestLoading,
    refetchExistingPermissionAccessRequest
  } = useExistingPermissionAccessRequestQuery({
    appLocationId
  });
  if (hasRequestAccessConfig && !isExistingPermissionAccessRequestLoading && existingPermissionAccessRequest) {
    var _requestAccessConfig$2, _requestAccessConfig$3;
    return /*#__PURE__*/_jsx(ExistingRequestFullPageDisplay, Object.assign({
      existingPermissionAccessRequest: existingPermissionAccessRequest,
      appLocationLabel: (_requestAccessConfig$2 = requestAccessConfig === null || requestAccessConfig === void 0 || (_requestAccessConfig$3 = requestAccessConfig.appLocation) === null || _requestAccessConfig$3 === void 0 ? void 0 : _requestAccessConfig$3.label) !== null && _requestAccessConfig$2 !== void 0 ? _requestAccessConfig$2 : ''
    }, rest));
  }
  return /*#__PURE__*/_jsx(BlockedFullPageDisplay, Object.assign({
    taskDescription: taskDescription,
    hasRequestAccessConfig: hasRequestAccessConfig,
    isExistingPermissionAccessRequestLoading: isExistingPermissionAccessRequestLoading,
    requestAccessConfig: requestAccessConfig,
    onRequestAccessSuccess: refetchExistingPermissionAccessRequest
  }, rest));
}